import React from 'react';
import moment from 'moment';
import Moment from 'moment-timezone';
import { AppSettings } from '../constants';
import * as BuilderActionType from 'Builders/constants';

/* eslint-disable */
export const arrayToJson = array => {
  var json = {};
  array.forEach(item => {
    json[item["name"]] = item["value"];
  });
  // $.map(array, function (n, i) {
  //     json[n['name']] = n['value'];
  // });
  return json;
};

export const isEmpty = val => {
  if (val === "" || val === null) {
    return true;
  }

  return false;
};

export const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export function print(content) {
  const pri = document.getElementById("ifmcontentstoprint").contentWindow;
  const isChrome = Boolean(pri.chrome);
  const iframe = document.getElementById("ifmcontentstoprint");
  pri.document.open();
  pri.document.write(content);
  iframe.onload = () => {
  pri.focus();
  pri.print();
  pri.document.close();
  // pri.document.close(); // necessary for IE >= 10s
  }
  pri.document.close();
  // if(isChrome){
  //   setTimeout(() => {
  //     // wait until all resources loaded
  //     pri.document.close(); // necessary for IE >= 10
  //     pri.focus();
  //     pri.print();
  //     pri.document.close();
  //   }, 500);
  // } else {
  //   pri.document.close(); // necessary for IE >= 10
  //   pri.focus(); // necessary for IE >= 10
  //   pri.print();
  //   pri.document.close();
  // }
}

export function printEOF(content) {
  const pri = document.getElementById("ifmcontentstoprint").contentWindow;
  const isChrome = Boolean(pri.chrome);
  pri.document.open();
  pri.document.write(content);
  if(isChrome){
    setTimeout(() => {
      // wait until all resources loaded
      pri.document.close(); // necessary for IE >= 10
      pri.focus();
      pri.print();
      pri.document.close();
    }, 500);
  } else {
    pri.document.close(); // necessary for IE >= 10
    pri.focus(); // necessary for IE >= 10
    pri.print();
    pri.document.close();
  }
}

export function daysBetween(date1, date2) {
  //Get 1 day in milliseconds
  var one_day = 1000 * 60 * 60 * 24;

  // Convert both dates to milliseconds
  var date1_ms = date1.setHours(0, 0, 0, 0);
  var date2_ms = date2.setHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds
  var difference_ms = date2_ms - date1_ms;

  // Convert back to days and return
  return parseInt(difference_ms / one_day);
}

export function findAndReplaceASCIICode(string) {
  return string.replace(/[^\x00-\x7F]/g, "_");
}

export function decimalFixed(num, lengthToFixed = 2, rounding = false) {
  const stringNum = num ? num.toString() : "";
  const decimalString =
    stringNum.indexOf(".") !== -1 ? stringNum.split(".").pop() : "";
  if (decimalString && decimalString.length) {
    if (decimalString.length > 2) {
      if (rounding) {
        return parseFloat(num).toFixed(lengthToFixed);
      }
      return Number(
        stringNum.slice(0, stringNum.indexOf(".") + (lengthToFixed + 1))
      );
    }
    return parseFloat(num);
  }

  return parseFloat(num);
}

export function calculateAgeWorkOrder(item) {
  if (item.lastSentDate) {
    const offsetSentDate = daysBetween(
      new Date(moment.utc().format()),
      new Date(item.lastSentDate)
    );
    const overdue = daysBetween(
      new Date(item.dueDate),
      new Date(item.lastSentDate)
    );
    const offset = offsetSentDate - overdue;
    const style = offset >= 0 ? "remaining-day-txt" : "text-danger";
    const day =
      offsetSentDate === 1 || offsetSentDate === -1 || offsetSentDate === 0
        ? "day"
        : "days";
    if (item.status === 1) {
      return (
        <span className={style}>{`${Math.abs(offsetSentDate)} ${day}`}</span>
      );
    }
    return "-";
  }
  return "-";
}

export function handleRedBarTableWorkOrder(item) {
  if (item.lastSentDate) {
    const offsetSentDate = daysBetween(
      new Date(moment.utc().format()),
      new Date(item.lastSentDate)
    );
    const overdue = daysBetween(
      new Date(item.dueDate),
      new Date(item.lastSentDate)
    );
    const offset = offsetSentDate - overdue;
    if (offset < 0 && item.status === 1) {
      return "overdue-tr";
    }
    return "";
  }
  return "";
}

export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return "";
}

export function renderAgeOfWorkOrder(item) {
  const { overdue, status } = item;

  let className = "";

  if (status === 0 || status === 2 || status === 3 || status === 7) {
    return <span>-</span>;
  }

  if (status === 1) {
    if (overdue) {
      className = "text-danger";
    } else {
      className = "remaining-day-txt";
    }
  }

  if (item.age !== null) {
    return <span className={className}>{item.age}</span>;
  }

  return <span>-</span>;
}

export function checkIsOverdueWorkOrder(item) {
  return item.status === 1 && item.overdue ? "overdue-tr" : "";
}

export function formatTimezoneDateTime(value, useCurrentTime = true) {
  if (useCurrentTime) {
    return Moment.tz(
      value.set({
        hour: Moment().hour(),
        minute: Moment().minute(),
        second: Moment().second()
      }),
      AppSettings.TIMEZONE
    ).format();
  }
  return Moment.tz(value, AppSettings.TIMEZONE).format();
}

export function parseTimezone(value, format = "MM/DD/YYYY") {
  return Moment.tz(value, AppSettings.TIMEZONE).format(format);
}

export function toggleScrollBody(condition) {
  if (condition) {
    //condition === true then allow body scroll
    document.getElementsByTagName("BODY")[0].classList.remove("no-scroll");
  } else {
    //condition === false then prevent body scroll
    document.getElementsByTagName("BODY")[0].classList.add("no-scroll");

    if (window.innerWidth < 768) {
      window.scrollTo(0, 0);
    }
  }
}

export function scrollToTop() {
  if (window.innerWidth < 768) {
    window.scrollTo(0, 0);
  }
}

export function initialSizePerPage(
  tableName,
  pageSizeReferenceProp,
  defaultSizePerPage
) {
  if (
    pageSizeReferenceProp[AppSettings.CLIENT_ID] &&
    pageSizeReferenceProp[AppSettings.CLIENT_ID][
      localStorage[AppSettings.S1_UID]
    ] &&
    pageSizeReferenceProp[AppSettings.CLIENT_ID][
      localStorage[AppSettings.S1_UID]
    ][tableName]
  ) {
    return pageSizeReferenceProp[AppSettings.CLIENT_ID][
      localStorage[AppSettings.S1_UID]
    ][tableName];
  } else {
    return defaultSizePerPage;
  }
}

export function dispatchActionSetPageSizeReference(
  dispatch,
  tableName,
  pageSize
) {
  if (AppSettings.clientTypeValue === "Builder") {
    const clientId = AppSettings.CLIENT_ID;

    const userId = localStorage[AppSettings.S1_UID];

    dispatch({
      type: BuilderActionType.SET_PAGE_SIZE_REFERENCE,
      params: {
        clientId,
        userId,
        tableName,
        pageSize
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/helper/unit-helper.js